import swal from "sweetalert";

export const VolverAlLogin = () => {
    swal("", "Su sesión ha expirado, favor de iniciar sesión nuevamente.","error");
    // alert("La sesión del usuario esta vencida favor iniciar nuevamente ");
    setTimeout(() => {
      localStorage.clear();
      window.location.replace("/auth/login");
    }, 3500);
  }

export const truncateString = (str, num) => {
 return str && str.length > num ? str.slice(0, num) + "..." : str;
};

export const getSemaforoStyle = (puntuacion) => {
  const p = Number(puntuacion);

  let backgroundColor = "#ffffff";
  let color = "#000000";

  if (puntuacion === null || puntuacion === undefined || Number.isNaN(p)) {
    backgroundColor = "#fff"; // Blanco sin datos
  } else if (p >= 0 && p <= 10) {
    backgroundColor = "#C00000"; // Rojo (5%)
    color = "#ffffff";
  }
  else if (p >= 11 && p <= 60) backgroundColor = "#FFC000"; // Naranja (30%)
  else if (p >= 61 && p <= 70) { backgroundColor = "#FFFF00"; color = "black"; } // Amarillo (65%)
  else if (p >= 71 && p <= 80) { backgroundColor = "#8ED973"; color = "black"; } // Verde Mas Claro (75%)
  else if (p >= 81 && p <= 90) { backgroundColor = "#47D45A"; color = "black"; } // Verde claro (85%)
  else if (p >= 91 && p <= 100) {
    backgroundColor = "#13501B"; // Verde oscuro (95%)
    color = "#ffffff";
  }

  return {
    backgroundColor,
    color,
    padding: "4px 8px",
    // borderRadius: "4px",
    fontWeight: "bold",
    display: "inline-block",
    minWidth: "60px",
    textAlign: "center"
  };
};

export const resultadoToNumber = (valor) => {
  switch((valor || "").toLowerCase()) {
    case 'cumplio': return 2;
    case 'parcial': return 1;
    case 'no cumple': return 0;
    case 'no_cumplio': return 0;
    case 'no_aplica': return 2;
    default: return 0;
  }
}

export const poaUsaPuntuacion = (poa) => Number(poa?.ano) >= 2026;

export const VALOR_NO_APLICA_EVALUACION = "no_aplica";

export const CRITERIO_AUSENCIA_DEMANDA_ID = 9;

const CRITERIO_AUSENCIA_DEMANDA =
  "Ausencia de demanda del producto o actividad programada";

const normalizarTexto = (texto = "") =>
  (texto ?? "")
    .toString()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();

export const esValorNoAplica = (value) =>
  ["n/a", "no_aplica"].includes(normalizarTexto(value));

export const esCriterioAusenciaDemanda = (criterio) =>
  normalizarTexto(criterio?.descripcion).includes(
    normalizarTexto(CRITERIO_AUSENCIA_DEMANDA)
  );

export const obtenerPuntuacionTotalCriterios = (criterios = []) =>
  criterios.reduce(
    (total, criterio) => total + (parseFloat(criterio.valorMaximo) || 0),
    0
  );

export const evaluacionEsAusenciaDemanda = (evaluaciones = [], criterios = []) => {
  const listaEvaluaciones = Array.isArray(evaluaciones) ? evaluaciones : [];
  const criterioAusenciaDemanda =
    criterios.find(esCriterioAusenciaDemanda) ||
    listaEvaluaciones.find(
      (evaluacion) =>
        Number(evaluacion.criterioId) === CRITERIO_AUSENCIA_DEMANDA_ID
    );

  if (!criterioAusenciaDemanda) return false;

  return listaEvaluaciones.some((evaluacion) => {
    if (Number(evaluacion.criterioId) !== Number(criterioAusenciaDemanda.criterioId)) {
      return false;
    }

    if (esValorNoAplica(evaluacion.resultado)) return true;

    const resultado = parseFloat(evaluacion.resultado);
    return !Number.isNaN(resultado) && resultado > 0;
  });
};

const toNumberOrNull = (value) => {
  if (value === null || value === undefined || value === "") return null;
  if (esValorNoAplica(value)) return VALOR_NO_APLICA_EVALUACION;

  const numberValue = Number(value);
  return Number.isNaN(numberValue) ? null : numberValue;
};

export const obtenerPuntuacionPorTrimestre = (evaluaciones, trimestre) => {
  if (!evaluaciones) return null;

  const trimKey = `t${trimestre}`;

  if (Array.isArray(evaluaciones)) {
    const evaluacionesTrimestre = evaluaciones.filter((evaluacion) => {
      if (!evaluacion) return false;
      if (evaluacion.trimestre === undefined || evaluacion.trimestre === null) {
        return true;
      }

      return Number(evaluacion.trimestre) === Number(trimestre);
    });

    if (evaluacionesTrimestre.length === 0) return null;
    if (
      evaluacionesTrimestre.some(
        (evaluacion) =>
          esValorNoAplica(evaluacion.resultado) ||
          esValorNoAplica(evaluacion.puntuacion) ||
          esValorNoAplica(evaluacion.puntaje)
      )
    ) {
      return VALOR_NO_APLICA_EVALUACION;
    }

    return evaluacionesTrimestre.reduce(
      (total, evaluacion) =>
        total + (toNumberOrNull(evaluacion.resultado ?? evaluacion.puntuacion ?? evaluacion.puntaje) || 0),
      0
    );

  }

  const valorTrimestre = toNumberOrNull(evaluaciones[trimKey]);
  if (valorTrimestre !== null) return valorTrimestre;

  return toNumberOrNull(
    evaluaciones.resultado ?? evaluaciones.puntuacion ?? evaluaciones.puntaje
  );
};
